export default __webpack_public_path__ + "static/media/PrintIcon.fbf3be22.svg";